import * as React from 'react'

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={295} height={168} viewBox="0 0 295 168" fill="none" {...props}>
      <g filter="url(#prefix__filter0_d)">
        <rect x={4} width={287} height={160} rx={15} fill="#3F5A83" />
      </g>
      <path
        d="M171.293 0C171.293 91 87 103 87 160H276C284.284 160 291 153.284 291 145V15C291 6.71573 284.3 0 276.016 0H171.293Z"
        fill="#395175"
      />
      <rect
        x={24.5}
        y={21.5}
        width={42.154}
        height={32}
        rx={3.5}
        fill="url(#prefix__paint1_linear)"
        stroke="#B1831F"
      />
      <path
        d="M38.695 41.307c-.202.801-.31 1.654-.31 2.538 0 4.673 3.03 8.462 6.769 8.462 3.738 0 6.77-3.789 6.77-8.462 0-.884-.11-1.737-.31-2.538-.18-.705-.537-2.454-.537-3.808 0-1.354 1.128-3.102 1.692-3.808h14.385M51.923 42.154h15.23M38.385 33.691H24M38.385 42.154H24M51.71 29.038c-.752-3.65-3.402-6.347-6.556-6.347-3.739 0-6.77 3.789-6.77 8.462 0 .884.11 1.737.31 2.538.18.706.537 2.454.537 3.808 0 1.354-.358 3.103-.536 3.808"
        stroke="#B1831F"
      />
      <rect x={217} y={19} width={54} height={36} rx={2} fill="#fff" />
      <path
        d="M224.272 33.093h1.7l-.85-2.122-.85 2.122zM233.308 40.219v.985h2.859v1.062h-2.859v1.137h3.167l1.468-1.592-1.39-1.592h-3.245zM255.634 30.97l-.927 2.123h1.777l-.85-2.122zM241.576 44.008v-4.32l-2.009 2.122 2.009 2.198zM245.36 40.901c-.077-.455-.387-.682-.85-.682h-1.622v1.364h1.699c.464 0 .773-.227.773-.682zM250.77 41.432c.155-.076.232-.303.232-.53.078-.303-.077-.455-.232-.531-.154-.076-.386-.076-.617-.076h-1.546v1.213h1.546c.231 0 .463 0 .617-.076z"
        fill="#117DF7"
      />
      <path
        d="M261.891 29v.91l-.463-.91h-3.631v.91l-.464-.91h-4.944c-.849 0-1.545.152-2.162.455V29h-3.477v.455c-.386-.303-.849-.455-1.467-.455h-12.438l-.85 1.895-.849-1.895H227.206v.91l-.386-.91h-3.399l-1.545 3.563-1.777 3.865-.033.077h4.022l.028-.077.464-1.136h1.004l.464 1.212h4.48V35.596l.386.91h2.24l.386-.91V36.504h10.738v-1.97h.155c.154 0 .154 0 .154.227v1.668h5.562v-.455c.464.228 1.159.455 2.086.455h2.318l.463-1.213h1.081l.464 1.213h4.48V35.29l.696 1.138h3.63V29h-3.476zm-26.187 6.368h-1.237v-4.17l-.077.174v-.002l-1.797 3.998h-1.138l-1.854-4.17v4.17h-2.627l-.54-1.137h-2.627l-.541 1.137h-1.358l2.285-5.307h1.931l2.163 5.08v-5.08h2.047l.036.076h.003l.975 2.082.7 1.56.024-.08 1.545-3.637h2.086v5.306h.001zm5.33-4.17h-3.013v.986h2.936v1.061h-2.936v1.062h3.013v1.136h-4.326v-5.381h4.326v1.136zm5.51 1.955a.85.85 0 01.082.094c.148.19.268.474.274.889l.001.021.001.013v.006c.002.042.003.084.003.13v1.062h-1.159v-.607c0-.303 0-.758-.232-1.061a.707.707 0 00-.227-.153c-.116-.073-.335-.074-.7-.074h-1.391v1.895h-1.312V30.06h2.935c.695 0 1.159 0 1.545.228.379.223.607.593.616 1.179-.018.806-.546 1.249-.925 1.398 0 0 .258.051.489.287zm2.601 2.215h-1.313V30.06h1.313v5.307zm15.064 0h-1.7l-2.472-4.018v3.335l-.008-.008v.694h-1.305v-.003h-1.313l-.464-1.137h-2.704l-.463 1.212h-1.468c-.618 0-1.391-.151-1.854-.606-.463-.455-.695-1.061-.695-2.046 0-.758.154-1.517.695-2.123.386-.455 1.082-.607 1.931-.607h1.237v1.137h-1.237c-.463 0-.695.076-1.004.304-.231.227-.386.682-.386 1.212 0 .607.077.986.386 1.289.232.228.541.304.927.304h.541l1.776-4.17h1.932l2.163 5.08v-5.079h1.931l2.24 3.714v-3.714h1.314v5.23z"
        fill="#117DF7"
      />
      <path
        d="M245.441 32.27a.42.42 0 00.061-.08.808.808 0 00.107-.573.483.483 0 00-.012-.069l-.003-.017h-.001a.426.426 0 00-.234-.258c-.155-.076-.387-.076-.618-.076h-1.546v1.213h1.546c.231 0 .463 0 .618-.076a.305.305 0 00.064-.045v.001l.018-.02zM268.766 42.948c0-.53-.154-1.061-.386-1.44v-3.41h-.003v-.229h-3.72c-.482 0-1.066.455-1.066.455v-.455h-3.554c-.541 0-1.235.152-1.545.455v-.455h-6.334v.455c-.463-.379-1.314-.455-1.7-.455h-4.171v.455c-.386-.379-1.314-.455-1.778-.455h-4.634l-1.082 1.137-1.004-1.137h-6.952v7.657h6.798l1.117-1.097.968 1.097h4.326v-1.744h.387c.54 0 1.236 0 1.776-.227V45.6h3.477V43.63h.154c.232 0 .232 0 .232.228V45.6h10.506c.695 0 1.39-.152 1.776-.455V45.601h3.322c.695 0 1.391-.075 1.854-.379.712-.419 1.16-1.16 1.227-2.044l.009-.078-.005-.005c.003-.049.005-.097.005-.147zm-24.333-.454h-1.545V44.464h-2.539l-1.478-1.667-.005.005-.073-.081-1.699 1.743h-4.944v-5.306h5.021l1.372 1.475.289.308.039-.04 1.622-1.743h4.094c.795 0 1.685.193 2.022.986.04.157.064.332.064.53 0 1.516-1.082 1.82-2.24 1.82zm7.725-.076c.154.227.232.53.232.985v1.061h-1.314v-.682c0-.303 0-.834-.232-1.061-.154-.227-.463-.227-.926-.227h-1.391v1.97h-1.313v-5.382h2.935c.618 0 1.159 0 1.546.228.386.227.695.606.695 1.213 0 .833-.541 1.288-.927 1.44.386.151.618.303.695.455zm5.33-2.199h-3.013v.986h2.936v1.061h-2.936v1.061h3.013v1.137h-4.326v-5.382h4.326v1.137zm3.245 4.245h-2.473v-1.137h2.473c.231 0 .386 0 .541-.151a.575.575 0 00.154-.38.574.574 0 00-.154-.378c-.078-.076-.233-.152-.464-.152-1.236-.076-2.704 0-2.704-1.667 0-.758.463-1.592 1.854-1.592h2.549v1.288h-2.395c-.231 0-.386 0-.541.076-.154.076-.154.228-.154.38 0 .227.154.303.309.378.155.076.309.076.463.076h.696c.695 0 1.159.151 1.468.455.231.227.386.606.386 1.137 0 1.136-.695 1.667-2.008 1.667zm6.643-.53c-.309.303-.85.53-1.622.53h-2.472v-1.137h2.471c.232 0 .387 0 .541-.151a.575.575 0 00.155-.38.574.574 0 00-.155-.378c-.077-.076-.231-.152-.463-.152-1.236-.076-2.704 0-2.704-1.667 0-.72.42-1.371 1.456-1.565.124-.017.255-.027.398-.027h2.55v1.288h-2.395c-.232 0-.386 0-.541.076a.576.576 0 00-.155.38c0 .227.078.303.31.378.154.076.308.076.463.076h.695c.338 0 .593.04.827.121.214.076.922.387 1.08 1.199.014.085.024.173.024.272 0 .455-.154.834-.463 1.136z"
        fill="#117DF7"
      />
      <defs>
        <linearGradient
          id="prefix__paint0_linear"
          x1={134}
          y1={160}
          x2={291}
          y2={160}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#395175" />
          <stop offset={1} stopColor="#395175" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="prefix__paint1_linear"
          x1={24}
          y1={21}
          x2={67.154}
          y2={54}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7C966" />
          <stop offset={0.516} stopColor="#FFE7BD" />
          <stop offset={1} stopColor="#E1A448" />
        </linearGradient>
        <filter
          id="prefix__filter0_d"
          x={0}
          y={0}
          width={295}
          height={168}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  )
}

export default SvgComponent
